export default function findObject(
  dataSource,
  dataSourceProperty,
  valueToMatch
) {
  return dataSource.find(object => object[dataSourceProperty] === valueToMatch)
}
